// The verdict strip — the 30-second answer: how many accounts, how many need
// looking at. Clicking a segment filters the alerts panel + the book table.

import { cn } from '../../lib/utils';
import type { HomeAccountHealth } from '../../types/advertisingHome';

export type HealthFilter = HomeAccountHealth | null;

export function VerdictStrip({
  counts,
  filter,
  onFilter,
}: {
  counts: { total: number; critical: number; attention: number; ontrack: number };
  filter: HealthFilter;
  onFilter: (next: HealthFilter) => void;
}): React.JSX.Element {
  const segment = (
    label: string,
    value: number,
    key: HomeAccountHealth | null,
    tone: string,
    dot?: string,
  ) => (
    <button
      type="button"
      onClick={() => onFilter(filter === key ? null : key)}
      aria-pressed={filter === key}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors',
        filter === key
          ? 'border-foreground/30 bg-accent font-medium'
          : 'border-border bg-card hover:bg-accent',
        tone,
      )}
    >
      {dot && <span className={cn('h-2 w-2 rounded-full', dot)} aria-hidden />}
      <span className="font-semibold tabular-nums">{value}</span>
      {label}
    </button>
  );

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-muted-foreground">
        <span className="font-semibold text-foreground">{counts.total}</span> accounts ·
      </span>
      {segment('on track', counts.ontrack, 'ontrack', 'text-foreground', 'bg-kyck-500')}
      {segment('need attention', counts.attention, 'attention', 'text-amber-700', 'bg-amber-500')}
      {segment('critical', counts.critical, 'critical', 'text-red-700', 'bg-red-500')}
    </div>
  );
}
